import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom'

export function RouteError() {
  const err = useRouteError()
  const text = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : 'Unknown error'
  return (
    <div className="page narrow" data-testid="web-route-error">
      <h1>Something went wrong</h1>
      <p className="muted">{text}</p>
      <p>
        <Link to="/">Back to start</Link>
      </p>
    </div>
  )
}
